/** Format an integer amount expressed in the currency's minor unit. */
export function formatMinorCurrencyAmount(amount: number, currency = 'usd'): string {
  const normalizedCurrency = currency.toUpperCase()
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: normalizedCurrency,
  })
  const fractionDigits = formatter.resolvedOptions().maximumFractionDigits ?? 2

  return formatter.format(amount / 10 ** fractionDigits)
}
